
/*
This is used for both adding and editing dailylogs along with the associated tasks
this is being replaced by DailyLogForm component used for both
adding and editing tasks along with tasks
*/
import React, { Component } from "react";
import { Table, Navbar, NavbarBrand, Nav, NavbarToggler, Collapse, NavItem, Row, Col, Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Alert } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { Control, LocalForm, Errors } from 'react-redux-form';
import { v4 as uuid } from 'uuid';
import { connect } from 'react-redux';
import { postTaskCommon, updateTaskCommon, fetchComments, postComment, postTask, fetchTasks, addNewTask, updateLog, saveUpdatesToLog, updateTask, updateTaskStatus } from '../redux/ActionCreators';
import { ConfigureStore, store } from "../redux/ConfigureStore";
import DatePicker from 'react-datepicker';
import AddTaskCommon from './AddTaskCommon';

import "react-datepicker/dist/react-datepicker.css";
import 'bootstrap/dist/css/bootstrap.min.css';

import isEqual from 'lodash/isEqual';



function RenderTasks({ task, onClick, onTaskClick }) {
    let dtDue;
    try {
        dtDue = new Intl.DateTimeFormat('en-AU', { weekday: 'short', year: 'numeric', month: 'short', day: '2-digit' }).format(new Date(Date.parse(task.due)));
    }
    catch (error) {
        dtDue = "";
    }
    //     console.log ("in render status: " +task.task );
    // console.log ("in render status: " +task.status );


    const handleTaskClick = () => {
        // Ensure that onTaskClick receives the correct task.id value
        //    alert("tsk " + task.id);
        //alert("handleTaskClick called")
        onTaskClick(task._id);
    };

    if (task.status == "open" || task.status == "") {
        return (

            <tr onClick={(event) => onClick(event, task._id)}>
                <td>
                    <FormGroup check>
                        <Input
                            id="taskStatus"
                            type="checkbox"
                            onChange={(event) => onClick(event, task._id)}
                            value={task._id}
                            checked={false}

                        />
                        {' '}
                        <Label check>
                            {task.task}
                        </Label>
                    </FormGroup>

                </td>
                <td>
                    {dtDue}

                </td>
            </tr>

        );
    }
    else if (task.status == "done") {
        return (

            <tr onClick={(event) => onClick(event, task._id)}>
                <td>
                    <FormGroup check >
                        <Input
                            id="taskStatus"
                            type="checkbox"
                            onChange={(event) => onClick(event, task._id)}
                            value={task._id}
                            checked={true}

                        />
                        {' '}
                        <Label check>
                            {task.task}
                        </Label>
                    </FormGroup>

                </td>

                <td>
                    {dtDue}
                </td>
            </tr>

        );

    }
}

const required = (val) => val && val.length;
const maxLength = (len) => (val) => !(val) || (val.length <= len);
const minLength = (len) => (val) => (val) && (val.length >= len);
const isNumber = (val) => !isNaN(Number(val));
const validEmail = (val) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val);


//state is passed as parameter. this state is the current state of the redux store
//Each field in the object will become a prop for your actual component
//The values in the fields will be used to determine if your component needs to re-render
const mapStateToProps = state => {
    //alert(state.dishes);
    return {
        tasks: state.tasks,
        log: state.log

    }
}

/*
allows you to specify which actions your component might need to dispatch
The mapDispatchToProps function will be called with dispatch as the first argument. 
You will normally make use of this by returning new functions that call dispatch() inside themselves, 
and either pass in a plain action object directly or pass in the result of an action creator
Each field in the object will become a separate prop for your own component, 
and the value should normally be a function that dispatches an action when called 
The return of the mapDispatchToProps function will be merged to your connected component as props. 
You may call them directly to dispatch its action.
*/
const mapDispatchToProps = (dispatch) => ({

    updateTaskCommon: (tasks, taskId, onSuccessCallback) => { dispatch(updateTaskCommon(tasks, taskId, onSuccessCallback)) },
    postTaskCommon: (tasks, onSuccessCallback) => { dispatch(postTaskCommon(tasks, onSuccessCallback)) },
    fetchTasks: (id) => { dispatch(fetchTasks(id)) },
    addNewTask: (unique_id, dailylogid, tasks, task, duedate) => { dispatch(addNewTask(unique_id, dailylogid, tasks, task, duedate)) },
    updateLog: (id, subject, topic, subtopic, comment) => { dispatch(updateLog(id, subject, topic, subtopic, comment)) },
    saveUpdatesToLog: (id, subject, topic, subtopic, comment, noOfTasks, noOfDoneTasks) => { dispatch(saveUpdatesToLog(id, subject, topic, subtopic, comment, noOfTasks, noOfDoneTasks)) },
    updateTask: (unique_id, dailylogid, tasks, task, status) => { dispatch(updateTask(unique_id, dailylogid, tasks, task, status)) },
    updateTaskStatus: (unique_id, dailylogid, tasks, task, status) => { dispatch(updateTaskStatus(unique_id, dailylogid, tasks, task, status)) }

});




class AddTask extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isNavOpen: false,
            isModalOpen: false,
            disAddTask: true,
            strTask: "",
            strTaskStatus: "",
            startDate: new Date(),
            doneTasksNos: 0,
            isCommonTaskOpen: false,
            dailylogid: "",
            subject: "",
            topic: "",
            subtopic: "",
            calledfrom: "addtask",
            allTasks: "",
            taskId: "",
            getTasksTable: ""
        }
        this.toggleNav = this.toggleNav.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleUpdateLog = this.handleUpdateLog.bind(this);
        this.handleAddTask = this.handleAddTask.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleTaskClick = this.handleTaskClick.bind(this);

    }

    handleDateChange(date) {
        this.setState({
            startDate: date
        });
        // const d = new Date(date);
        // const dIso = d.toISOString();
        // alert (d.toISOString());
        // alert (new Intl.DateTimeFormat('en-AU', { year: 'numeric', month: 'short', day: '2-digit' }).format(new Date(Date.parse(dIso))));

    }

    handleTaskClick(taskId) {
        //alert("handleTaskClick " + taskId);

        this.setState({
            taskId: taskId
        });

    }


    //this is to reflect the changes made to the text boxes right away in the form by 
    //updating the state through redux reducer function
    handleChange(event, taskId) {

        if (this.state.isModalOpen == true) {
            // alert(" occured " + event.target.id);
            // alert(" occured " + event.target.value);

            switch (event.target.id) {
                case "subject":
                    //  alert(" inside subject " + event.target.value);
                    this.props.updateLog(this.props.dailylog.id, event.target.value, this.props.log.topic, this.props.log.subtopic, this.props.log.comments);
                    return;
                case "topic":
                    // alert(" inside topic " + event.target.value);
                    this.props.updateLog(this.props.dailylog.id, this.props.log.subject, event.target.value, this.props.log.subtopic, this.props.log.comments);
                    return;
                case "subtopic":
                    // alert(" inside subtopic " + event.target.value);
                    this.props.updateLog(this.props.dailylog.id, this.props.log.subject, this.props.log.topic, event.target.value, this.props.log.comments);
                    return;
                case "comment":
                    // alert(" inside subtopic " + event.target.value);
                    this.props.updateLog(this.props.dailylog.id, this.props.log.subject, this.props.log.topic, this.props.log.subtopic, event.target.value);
                    return;
                case "task":
                    // alert(" inside subtopic " + event.target.value);
                    if (event.target.value.length > 0) {
                        this.setState({
                            disAddTask: false,
                            strTask: event.target.value,
                            strTaskStatus: "Open"
                        });
                        return;
                    } else {
                        this.setState({
                            disAddTask: true,
                            strTask: "",
                            strTaskStatus: ""
                        });
                        return;
                    }
                case "taskStatus":
                    //alert('check clicked ' + event.target.checked);
                    // alert('check clicked ' +event.target.checked);
                    //  alert('check clicked ' +event.target.checked);
                    // alert("event.target.id " + event.target.id);
                    // alert("taskId " + taskId);

                    const linkedTasks = this.props.allTasks;
                    //alert("event.target.value " + event.target.value);
                    //alert("filteredTask " + JSON.stringify(linkedTasks));


                    const filteredTask = linkedTasks.filter(task => task._id === taskId);
                    //alert("filteredTask " + JSON.stringify(filteredTask[0].task));

                    const task = {

                        task: filteredTask[0].task,
                        desc: filteredTask[0].desc,
                        priority: filteredTask[0].priority,
                        due: filteredTask[0].due,
                        status: event.target.checked === true ? "done" : "open",
                        subject: filteredTask[0].subject,
                        topic: filteredTask[0].topic,
                        subtopic: filteredTask[0].subtopic,
                        dailylogid: filteredTask[0].dailylogid,
                        projectid: "",
                        parentid: ""
                    }

                    this.props.updateTaskCommon(task, taskId, this.updateTaskId);
                    return
                case "":
                 this.handleTaskClick(taskId);

            }

        }

    }


    componentDidMount() {
        this.setState({
            allTasks: this.props.allTasks
        });

        //alert("component did mount called " + this.props.allTasks);
        try {
            const linkedTasks = this.props.allTasks;
            const filteredTasks = linkedTasks.filter(task => task.dailylogid === this.props.dailylog.id);
            filteredTasks.sort((a, b) => (a.due > b.due ? -1 : 1));

            // Update the state to trigger a re-render
            this.setState({
                getTasksTable: filteredTasks.map(task => (
                    <RenderTasks task={task} onClick={this.handleChange} onTaskClick={this.handleTaskClick} />
                ))
            });
        } catch (error) {
            // Handle error if needed
        }


    }



    toggleNav() {
        this.setState({
            isNavOpen: !this.state.isNavOpen
        });
    }


    // In your parent component
    updateTaskId = (newTaskId) => {
        //alert ("update task id called ")
        this.setState({
            dailylogid: "",
            subject: "",
            topic: "",
            subtopic: "",
            calledfrom: "",
            taskId: "",
            allTasks: this.props.allTasks
        }, () => {
            // Code to execute after state is updated
            // This will be called once the state is updated and the component is re-rendered
            // You can place your logic or function calls here
            //console.log("State updated successfully!");
            try {
                //console.log ("new allTask " + JSON.stringify(this.props.allTasks));
                const linkedTasks = this.props.allTasks;
                const filteredTasks = linkedTasks.filter(task => task.dailylogid === this.props.dailylog.id);
                filteredTasks.sort((a, b) => (a.due > b.due ? -1 : 1));

                // Update the state to trigger a re-render
                this.setState({
                    getTasksTable: filteredTasks.map(task => (
                        <RenderTasks task={task} onClick={this.handleChange} onTaskClick={this.handleTaskClick} />
                    ))
                });
            } catch (error) {
                // Handle error if needed
            }
        });
    }


    toggleModal() {

        //alert (this.state.isModalOpen);

        // this.setState({
        //     isModalOpen: !this.state.isModalOpen
        // }, () => {alert (this.state.isModalOpen)});

        if (this.state.isModalOpen == true) {
            this.setState({
                dailylogid: "",
                subject: "",
                topic: "",
                subtopic: "",
                calledfrom: "",
                taskId: "",
                allTasks: this.props.allTasks,
                getTasksTable: ""
            });
        }

        this.setState({
            isModalOpen: !this.state.isModalOpen
        });



        if (this.state.isModalOpen == false) {
            var timestamp = new Date().toISOString();
            //console.log(timestamp + ' before calling fetch task. dailylogid ' + this.props.dailylog.id);
            this.props.fetchTasks(this.props.dailylog.id);
            //setTimeout(console.log(timestamp + ' before while loop ' + this.props.tasks.isLoading), 1000);
            //console.log(timestamp + ' before while loop ' + this.props.tasks.errMess);
            //updatelog is what updates the pop.log with what is passed with subject and other details. there is no DB call here, it is 
            //just copyin values from prop.dailylog  to prop.log via the redux store. whenever the fields are changed it gets updated in prop.log
            //with the help of updateLog. 
            this.props.updateLog(this.props.dailylog.id, this.props.dailylog.subject, this.props.dailylog.topic, this.props.dailylog.subtopic, this.props.dailylog.comments);
            var noOfDoneTasks = 0;
            try {
                noOfDoneTasks = this.props.dailylog.noOfDoneTasks;
                if (noOfDoneTasks == null || noOfDoneTasks == "") {
                    noOfDoneTasks = 0;
                }
            }
            catch (error) {
                noOfDoneTasks = 0;
            }

            this.setState({
                doneTasksNos: noOfDoneTasks
            });
            // alert (noOfDoneTasks);
            // alert (this.state.doneTasksNos);
        }
        else {

            //Purpose of this function is to just save the tasks status. so if there are no tasks loaded in this.props.tasks.tasks then we don't have to run this function
            if ((this.props.tasks.isLoading == false) && (this.props.tasks.errMess == null)) {
                //  this.props.updateTask("event.target.value", this.props.dailylog.id, this.props.tasks.tasks, this.state.strTask, "Done");
            }
        }
    }

    handleLogin(event) {

        this.toggleModal();
        // alert("Username: " + this.username.value + " Password:" + this.password.value);
        // alert("Username: " + this.username.value + " Password:" + this.password.value
        //     + " Remember: " + this.remember.checked);
        event.preventDefault();
    }

    handleUpdateLog(values) {
        if (typeof this.props.tasks.tasks.tasks === 'undefined' || this.props.tasks.tasks.tasks === null) {
            this.props.saveUpdatesToLog(this.props.log.id, this.props.log.subject, this.props.log.topic, this.props.log.subtopic, this.props.log.comments, 0, this.state.doneTasksNos);
        }
        else {
            this.props.saveUpdatesToLog(this.props.log.id, this.props.log.subject, this.props.log.topic, this.props.log.subtopic, this.props.log.comments, this.props.tasks.tasks.tasks.length, this.state.doneTasksNos);
        }
        this.toggleModal();
    }


    handleAddTask() {
        const unique_id = uuid();
        var timestamp = new Date().toISOString();

        // console.log(timestamp + ' errormsg ' + this.props.tasks.errMess);

        this.setState({
            isCommonTaskOpen: true
        })


    }

    handleSubmit(values) {

        //alert(values.subject);
        //alert(values.topic);
        //alert(values.subtopic);
        //alert(values.comment);

        this.toggleModal();

        // while(this.props.tasks.isLoading){

        //}

        const unique_id = uuid();
        var timestamp = new Date().toISOString();

        // console.log(timestamp + ' errormsg ' + this.props.tasks.errMess);

        if (this.props.tasks.errMess != null) {
            var timestamp = new Date().toISOString();
            // console.log(timestamp + ' inside addnewtask');
            this.props.addNewTask(unique_id, this.props.dailylog.id, values.topic);

        }
        else {
            var timestamp = new Date().toISOString();
            // console.log(timestamp + ' inside postask ' + JSON.stringify(this.props.tasks.tasks));
            this.props.postTask(unique_id, this.props.dailylog.id, this.props.tasks.tasks, values.topic);

        }

        //console.log("current state is :" + JSON.stringify(values));
        //alert("current state is :" + JSON.stringify(values));
        // alert(this.props.dishId);
        //alert(values.rating);
        //alert(values.author);
        //alert(values.comment);

    }


    componentDidUpdate(prevProps, prevState) {
        // Check if modal is opened (you can add your own condition)

        //alert(" componentDidUpdate called " + this.props.isOpen);

        // alert(" about to set the states.");
        // Your initialization code goes here
        // For example:
        // console.log("debug prevState.dailylogid " + prevState.dailylogid);
        // console.log("debug this.state.dailylogid " + this.state.dailylogid);
        //console.log("debug this.state.isModalOpen " + this.state.isModalOpen);

        if ((this.state.isModalOpen && this.state.dailylogid == "")) {
            //alert (JSON.stringify(this.props.allTasks));
            this.setState({

                dailylogid: this.props.dailylog.id,
                subject: this.props.dailylog.subject,
                topic: this.props.dailylog.topic,
                subtopic: this.props.dailylog.subtopic,
                calledfrom: "addtask",
                allTasks: this.props.allTasks

            }, () => {
                // Code to execute after state is updated
                // This will be called once the state is updated and the component is re-rendered
                // You can place your logic or function calls here
                //console.log("State updated successfully!");

            });

            try {
                //console.log ("new allTask " + JSON.stringify(this.props.allTasks));
                const linkedTasks = this.props.allTasks;
                const filteredTasks = linkedTasks.filter(task => task.dailylogid === this.props.dailylog.id);
                filteredTasks.sort((a, b) => (a.due > b.due ? -1 : 1));

                // Update the state to trigger a re-render
                //console.log("debug filteredTasks " + filteredTasks)
                this.setState({
                    getTasksTable: filteredTasks.map(task => (
                        <RenderTasks task={task} onClick={this.handleChange} onTaskClick={this.handleTaskClick} />
                    ))
                }, () => {
                    //  console.log("debug getTasksTable " + this.state.getTasksTable)
                });
            } catch (error) {
                //console.log("debug error " + error)
            }





        }




    }

    render() {



        return (
            <div>
                <Button outline onClick={this.toggleModal}>
                    <span className="fa fa-pencil fa-lg"></span> Add log
                </Button>
                <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal} size="lg">
                    <ModalHeader toggle={this.toggleModal} closeButton>Add Log</ModalHeader>
                    <ModalBody>
                        <LocalForm onSubmit={(values) => this.handleSubmit(values)}>


                            <Row className='form-group'>
                                <Label htmlFor="subject" md={1}>Subject</Label>
                                <Col md={5}>
                                    <Control.text model=".subject" id="subject" name="subject"
                                        placeholder="Subject"
                                        value={this.props.log.subject}
                                        className="form-control"
                                        onChange={(event) => this.handleChange(event)}
                                        validators={{ required, minLength: minLength(3), maxLength: maxLength(75) }}
                                    />
                                    <Errors className="text-danger"
                                        model=".subject"
                                        show="touched"
                                        messages={{
                                            required: 'Required',
                                            minLength: 'Must be greater than 2 characters',
                                            maxLength: 'Must be 75 characters or less'
                                        }}
                                    />

                                </Col>
                                <Label htmlFor="topic" md={1}>Topic</Label>
                                <Col md={5}>
                                    <Control.text model=".topic" id="topic" name="topic"
                                        placeholder="Topic"
                                        value={this.props.log.topic}
                                        className="form-control"
                                        onChange={(event) => this.handleChange(event)}
                                        validators={{ required, minLength: minLength(3), maxLength: maxLength(50) }}
                                    />
                                    <Errors className="text-danger"
                                        model=".topic"
                                        show="touched"
                                        messages={{
                                            required: 'Required',
                                            minLength: 'Must be greater than 2 characters',
                                            maxLength: 'Must be 50 characters or less'
                                        }}
                                    />

                                </Col>
                            </Row>



                            <Row className='form-group'>
                                <Label htmlFor="subtopic" md={1}>Subtopic</Label>
                                <Col md={5}>
                                    <Control.text model=".subtopic" id="subtopic" name="subtopic"
                                        placeholder="Subtopic"
                                        value={this.props.log.subtopic}
                                        className="form-control"
                                        onChange={(event) => this.handleChange(event)}
                                        validators={{ required, minLength: minLength(3), maxLength: maxLength(75) }}
                                    />
                                    <Errors className="text-danger"
                                        model=".subtopic"
                                        show="touched"
                                        messages={{
                                            required: 'Required',
                                            minLength: 'Must be greater than 2 characters',
                                            maxLength: 'Must be 75 characters or less'
                                        }}
                                    />

                                </Col>
                                <Col md={1}></Col>
                                <Col md={5}></Col>
                            </Row>
                            <Row>
                                <Col md={12}> &nbsp;</Col>
                            </Row>

                            <Row className='form-group'>
                                <Label htmlFor="comment" md={12}>Comment</Label>
                                <Col md={12}>
                                    <Control.textarea model=".comment" id="comment" name="comment"
                                        rows="6"
                                        value={this.props.log.comments}
                                        onChange={(event) => this.handleChange(event)}
                                        className="form-control" />
                                </Col>
                            </Row>
                            <Row className='form-group'>
                                <Col md={12}>
                                    {/* <Button type="submit" color="primary">Submit</Button> */}
                                    <Button color="primary" outline onClick={this.handleUpdateLog}>
                                        <span className="fa fa-pencil fa-lg"></span> Update log
                                    </Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12} className="bg-light border" ><div className="text-center text-uppercase">Tasks</div>  </Col>
                            </Row>

                            <Row className='form-group'>

                                <Col md={3}>
                                    <AddTaskCommon
                                        dailylogid={this.state.dailylogid}
                                        subject={this.state.subject}
                                        topic={this.state.topic}
                                        subtopic={this.state.subtopic}
                                        allTasks={this.props.allTasks}
                                        postTaskCommon={this.props.postTaskCommon}
                                        updateTaskCommon={this.props.updateTaskCommon}
                                        timetables={this.props.timetables}
                                        updateTaskId={this.updateTaskId}
                                        calledfrom={this.state.calledfrom}
                                        taskId={this.state.taskId}

                                    />
                                </Col>
                            </Row>


                        </LocalForm>
                        <hr />
                        <div className="table-responsive">
                            <Table border={1} striped bordered>
                                <thead>
                                    <tr>
                                        {/* <th>#</th> */}
                                        <th>Task</th>
                                        <th>Due</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.getTasksTable}


                                </tbody>
                            </Table>

                        </div>

                    </ModalBody>
                </Modal>
            </div>
        );
    }

}
export default connect(mapStateToProps, mapDispatchToProps)(AddTask); 